import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchOfficeLocations = createAsyncThunk('pbOfficeLocations/fetch', async (params, { rejectWithValue }) => {
  try { 
    const res = await service.getOfficeLocations(params)
    return { params, data: res.data, meta: res.meta } 
  } catch (e) { 
    return rejectWithValue(e.response?.data || e.message) 
  }
})

export const fetchOfficeLocation = createAsyncThunk('pbOfficeLocations/fetchOne', async (id, { rejectWithValue }) => { 
  try { 
    return await service.getOfficeLocation(id) 
  } catch (e) { 
    return rejectWithValue(e.response?.data || e.message) 
  } 
})

export const addOfficeLocation = createAsyncThunk('pbOfficeLocations/add', async (payload, { rejectWithValue }) => { 
  try { 
    return await service.addOfficeLocation(payload) 
  } catch (e) { 
    return rejectWithValue(e.response?.data || e.message) 
  } 
})

export const saveOfficeLocation = createAsyncThunk('pbOfficeLocations/save', async (payload, { rejectWithValue }) => { 
  try { 
    return await service.updateOfficeLocation(payload) 
  } catch (e) { 
    return rejectWithValue(e.response?.data || e.message) 
  } 
})

export const removeOfficeLocation = createAsyncThunk('pbOfficeLocations/remove', async (id, { rejectWithValue }) => { 
  try { 
    await service.deleteOfficeLocation(id)
    return id 
  } catch (e) { 
    return rejectWithValue(e.response?.data || e.message) 
  } 
})

const slice = createSlice({
  name: 'pbOfficeLocations',
  initialState: { 
    data: [], 
    meta: null, 
    params: { page: 1, take: 10, order: 'ASC', q: '' }, 
    selected: null, 
    loading: false, 
    error: null 
  },
  reducers: { 
    setOfficeLocationParams(s, a) { s.params = a.payload } 
  },
  extraReducers: b => {
    b.addCase(fetchOfficeLocations.pending, s => { s.loading = true })
     .addCase(fetchOfficeLocations.fulfilled, (s, a) => { 
       s.loading = false
       s.data = a.payload.data
       s.meta = a.payload.meta
       s.params = a.payload.params 
     })
     .addCase(fetchOfficeLocations.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchOfficeLocation.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addOfficeLocation.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveOfficeLocation.fulfilled, (s, a) => { 
       const i = s.data.findIndex(x => x.id === a.payload.id)
       if (i > -1) s.data[i] = a.payload 
     })
     .addCase(removeOfficeLocation.fulfilled, (s, a) => { 
       s.data = s.data.filter(x => x.id !== a.payload) 
     })
  }
})

export const { setOfficeLocationParams } = slice.actions
export default slice.reducer
